import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-businessowners',
    templateUrl: './businessowners.component.html',
    styleUrls: ['./businessowners.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BusinessownersComponent implements OnInit {
  status = false;
  constructor() { }

  ngOnInit() {
  }

}
